/* Algoritmo para trabajar la verificacion de usuarios mediante
 un login, ademas genera diferentes interacciones con el formulario */


//Import lib of node js
import $ from "jquery/dist/jquery.min";
import './components/pageComponent/button-ripple/ripple.js';

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';

import { PostRequest_Login, GetRequest, GetPlataformasMoviles } from './components/serverComponent/python/pythonAxios'
import { notify } from './components/pageComponent/alert/alert.js';
import { obtenerDatos } from './components/serverComponent/python/datosLogin'

import Swal from 'sweetalert2'
import { actualizarVariables } from "./components/configComponent/update-vars.js";
import { guardarEnStorage } from "./components/configComponent/storage.js";
import { almacenarVariable,getOne } from "./components/pwa-utils/db-informacion.js";
import { consultaB } from "./consultaB.js";

let d = document;
let date = new Date();
let insumos_iniciales
let id_back

let codigo_municipio = ''
let nombre_municipio = ''
let id_plataforma = ''
let nombre_plataforma = ''
var id_plataforma_param ;
let tipo_plataforma;
let plataformas_mun;


window.onload = () => {
  sessionStorage.clear();

  var params = new URLSearchParams(location.search);
  id_plataforma_param = params.get('id_plataforma');
  id_back = consultaB()

  //se valida que sí exista un B para guardar en la bd
  if (id_back != '' && id_back != null && id_back != undefined)  {
    //se envía la variable a la bd local
    almacenarVariable(id_back,'b')
  }

  var registrarSW = ()=>{
    ///PWA - registrar server worker
    if (navigator.serviceWorker) {
      navigator.serviceWorker.register('./sw.js')
    }
  }

  //se consulta una primera vez, para validar que ya esté activo el valor
  getOne('b').then(miB=>{
    registrarSW() //se registra el sw
  }).catch(()=>{
    //en caso de que falle (al ser primera vez de abrir la app)
    //se vuelve a consultar el dato para dar tiempo a la bd de registrar el valor
    getOne('b').then(miB=>{
      registrarSW()//se registra el sw
    })
  })

  
  // sessionStorage.setItem('id-plataforma', plataforma ? plataforma : 2)
  actualizarVariables()

  let dateFormat = date.getFullYear();
  d.querySelector('#elmYear').textContent = dateFormat;

  // Una vez cargue la pagina se cerrara el loading
  setTimeout(() => {
    d.querySelector('#section-loading').classList.add('d-none');
    d.querySelector('#section-loading').classList.remove('d-flex');
    d.querySelector('.box-text').classList.add('animate__fadeInLeft');
    d.querySelector('.form-box').classList.add('animate__fadeIn');
  }, 1);
}

// insumos iniciales de personalización de plataforma
const Api_inicial = GetPlataformasMoviles('autenticacion/insumos_iniciales/app movil')
Api_inicial.then(res => res.json())
  .then((response) => {
    insumos_iniciales = response    
    // //Datos de plataforma
    d.title = insumos_iniciales.PLATAFORMA_NAME + ' | Login'
    d.getElementById('name_plataforma').innerHTML = insumos_iniciales.PLATAFORMA_NAME
    d.getElementById('textoMunicipio').innerHTML = insumos_iniciales.DESCRIPCION
    d.getElementById('back-home').setAttribute('href',insumos_iniciales.HOME)
    sessionStorage.setItem('activar-encuesta', insumos_iniciales.APP_MOVIL_HABILITAR_CALIFICAR_PLATAFORMA)
    // //recover pass
    let btn_recover = d.getElementById('recover_password')
    btn_recover.setAttribute('href','recover_password.html?b='+id_back)
    // //Imagenes de plataforma
    let fondo_avif = d.getElementById('fondo_avif')
    fondo_avif.setAttribute('srcset',insumos_iniciales.IMG_FONDO_1)
    let fondo_otro = d.getElementById('fondo_otro')
    fondo_otro.setAttribute('srcset',insumos_iniciales.IMG_FONDO_2)
    let fondo_otros_navegadores = d.getElementById('fondo_otros_nav')
    fondo_otros_navegadores.setAttribute('src',insumos_iniciales.IMG_FONDO_2)
    // //Logo
    let logo_plataforma = d.getElementById('logo-Plataforma')
    logo_plataforma.setAttribute('src',insumos_iniciales.IMG_LOGO)
    
    let siglas_plataforma = d.getElementById('siglas_plataforma')
    siglas_plataforma.innerHTML = insumos_iniciales.SIGLAS
    if (insumos_iniciales.ALTO_LOGO) { //personalizar alto del logo del login
      if (insumos_iniciales.ALTO_LOGO > 0) {
        logo_plataforma.style.height = insumos_iniciales.ALTO_LOGO+'px'
      }
    }
    //Icono
    let icon = d.createElement('link')
    icon.setAttribute('rel','icon')
    icon.setAttribute('async',true)
    icon.setAttribute('href',insumos_iniciales.IMG_ICO)
    d.head.appendChild(icon)
    //Colores de la plataforma
    let colores = insumos_iniciales.COLORES
    asignarColores(colores)    
})

llenarSelectMunicipios()

function llenarSelectMunicipios() {
  let ApiMunicipio = GetPlataformasMoviles(`autenticacion/listado_municipios`)
  ApiMunicipio.then((response) => response.json())
    .then((municipios) => {
      if (municipios.length > 1) {
        $('#div_municipio').show()
        $('#select-municipio-login').removeAttr('disabled');
        for (let i = 0; i < municipios.length; i++) {
          let option = document.createElement('option')
          option.value = municipios[i].codigo_dane;
          let optionTexto = document.createTextNode(municipios[i].nombre);
          option.appendChild(optionTexto);
          $('#select-municipio-login').append(option);
        }

        $('#select-municipio-login').on('change', () => {
          codigo_municipio = ($('#select-municipio-login').val())
          $('#select-plataforma-login').empty()
          llenarSelectPlataformas()
        })

      } else if (municipios.length === 1) {
        codigo_municipio = municipios[0].codigo_dane
        nombre_municipio = municipios[0].nombre
        d.getElementById('municipio').innerHTML = nombre_municipio
        $('#div_municipio').remove();
        llenarSelectPlataformas()
      }
      validarSelects()
    }).catch((e)=>{
      validarSelects()
    })
}

function llenarSelectPlataformas() {
  $('#select-plataforma-login').removeAttr('disabled')
  let ApiPlataformas = GetPlataformasMoviles(`autenticacion/listado_plataformas/${codigo_municipio}`)
  ApiPlataformas.then((response) => response.json())
    .then((plataformas) => {
      plataformas_mun = plataformas;
      if (plataformas.length > 1) {
        $('#div_plataforma').show()
        for (let i = 0; i < plataformas.length; i++) {
          let option = document.createElement('option')
          option.value = plataformas[i].id;
          let optionTexto = document.createTextNode(plataformas[i].nombre);
          option.appendChild(optionTexto);
          $('#select-plataforma-login').append(option);
        }

        if(id_plataforma_param){
          $('#select-plataforma-login').val(id_plataforma_param)
        }

      } else if (plataformas.length == 1) {
        id_plataforma = plataformas[0].id
        nombre_plataforma = plataformas[0].nombre
        tipo_plataforma = plataformas[0].tipo_plataforma;
        $('#div_plataforma').remove();
      }
      validarSelects()
    }).catch((e)=>{
      validarSelects()
    })
}

//Función para cambiar el logo de mostrar contraseña
document.addEventListener('DOMContentLoaded', function () {
  $('i#see-password').on('click', function () {
    $(this)
      .find('[data-fa-i2svg]')
      .toggleClass('fa fa-eye-slash')
      .toggleClass('fa fa-eye');
  });
});

//Interacción para mostar la contraseña
var Password = document.getElementById('password');
var see_password = document.getElementById("see-password");
see_password.addEventListener("click", reveal_password);

//Función que descodifica la contraseña 
function reveal_password() {
  if (Password.type == "password") {
    Password.type = "text";
  }
  else {
    Password.type = "password";
  };
};

//Create interaction login botton, import data
let Botton = document.getElementById("botton");
Botton.onclick = Login;

window.addEventListener("keydown", function (event) {
  if (event.keyCode === 13) { Login() }
})

//Función para crear un mensaje de error. 
function error_message(mensaje, icon) {
  return Swal.fire({
    title: 'Error!',
    text: mensaje,
    icon: icon,
    confirmButtonText: 'OK'
  });
};

//Función para generar la conexion con la API y verifica los usuarios. 
export function Login() {
  if (!localStorage.getItem('location')) {
    notify('primary', {
      icon: 'fa-location-dot',
      message: 'Por favor activar la ubicación para acceder a la plataforma !',
    });
  }

  addLoading();
  var Email = document.getElementById('email').value;
  var Password = document.getElementById('password').value;
  let selectMunicipio =  codigo_municipio == '' ? document.getElementById('select-municipio-login') : null
  let selectePlataforma =  id_plataforma == '' ? document.getElementById('select-plataforma-login') : null

  id_plataforma = id_plataforma != '' ? id_plataforma : document.getElementById('select-plataforma-login').value
  nombre_plataforma = nombre_plataforma != '' ? nombre_plataforma : document.getElementById('select-plataforma-login').options[selectePlataforma.selectedIndex].text
  codigo_municipio = codigo_municipio != '' ? codigo_municipio : document.getElementById('select-municipio-login').value
  nombre_municipio = nombre_municipio != '' ? nombre_municipio : document.getElementById('select-municipio-login').options[selectMunicipio.selectedIndex].text

  // var Plataforma = document.getElementById('select-plataforma-login').value
  // let recaptcha = grecaptcha.getResponse();
  //let recaptcha ='pas'

  if (Email == "" || Password == "" ||  id_plataforma == '') {
    document.getElementById("email").focus();
    document.getElementById("password").focus();
    removeLoading();
    alert('Todos los campos son requeridos !');
  } else {
    sessionStorage.setItem('id-plataforma', id_plataforma);
    let plataforma_seleccionada = plataformas_mun.find(item => item.id == id_plataforma);
    sessionStorage.setItem('tipo_plataforma', plataforma_seleccionada.tipo_plataforma);
    actualizarVariables()
    // let select = document.getElementById('select-plataforma-login')
    // let nombrePlataforma = select.options[select.selectedIndex].text

    const Api_Login = PostRequest_Login(Email, Password, codigo_municipio);
    Api_Login.then(function (response) {
      if (response.statusText == "OK" || response.status == 200) {
        Api_Login.then((response) => response.json())
          .then((res) => {
            var tokenAcces = res.access;
            var tokenRefresh = res.refresh;
            let param = 'autenticacion/datos/usuario/'
            const Api_check = GetRequest(param, tokenAcces);
            Api_check.then((response) => response.json())
              .then((res1) => {
                removeLoading()
                
                let obj_datos = {
                  nombre_municipio,
                  codigo_municipio,
                  id_plataforma,
                  nombre_plataforma,
                  Email
                }

                guardarEnStorage(res1, tokenAcces, tokenRefresh,obj_datos)
                actualizarVariables()                

                navigator.geolocation.getCurrentPosition(showPosition, showError);
                
                function showPosition(position) {
                  localStorage.setItem('location', true);
                  
                  let plataformas_usuario = res1.acceso_plataformas
                  let ingreso = false
                  
                  for (let i = 0; i < plataformas_usuario.length; i++) {                 
                    if (plataformas_usuario[i].plataforma == nombre_plataforma && plataformas_usuario[i].rol == 'Reconocedor') {
                      ingreso = true
                    }
                  }
                  if (ingreso) {
                    obtenerDatos(Email, `Inicio sesión App Móvil - ${nombre_municipio}`, tokenAcces, 'autenticacion/geolocalizar/' + position.coords.longitude + '/' + position.coords.latitude, nombre_plataforma)
                    
                  } else {
                    error_message("El usuario no tiene acceso a la plataforma.", "info")
                    document.getElementById("email").value = ""
                    document.getElementById("password").value = ""
                  }

                }

                function showError(error) {
                  localStorage.removeItem('location');
                }
                
              }).catch(err => {
                removeLoading();
              });
          })
      }
      else {
        removeLoading();
        error_message("Usuario no registrado o credenciales incorrectas.", "error")
      }
    }).catch(err => {
      removeLoading();
    });
  }
};


function validarSelects() {
  if ($('#div_municipio')[0] && $('#div_plataforma')[0]) {
    see_password.classList.add('two-drop-active')
  } else if ($('#div_municipio')[0] || $('#div_plataforma')[0]) {
    see_password.classList.remove('two-drop-active')
    see_password.classList.add('one-drop-active')
  } else {
    see_password.classList.remove('two-drop-active')
    see_password.classList.remove('one-drop-active')
  }
}

function addLoading() {
  d.querySelector('#botton p').classList.add('d-none');
  d.querySelector('#botton .spinner-2').classList.remove('d-none');
}

function removeLoading() {
  d.querySelector('#botton p').classList.remove('d-none');
  d.querySelector('#botton .spinner-2').classList.add('d-none');
}

function asignarColores(colores) {
  colores.forEach(color => {
    document.documentElement.style.setProperty('--'+color.uso, color.color);
  });
}